
import React from 'react'
import FormField from './FormField'
import TagInput from './TagInput'

/**
 * TagInputField component.
 */

export default function TagInputField({ name, label, hint, placeholder, required, ...props }) {
  return <FormField
    name={name}
    label={label}
    hint={hint}
    required={required}
  >
    <TagInput
      name={name}
      required={required}
      {...props} />
  </FormField>
}